import React from 'react'

import { getBookmarkedMatchesUrl } from '../../../api'
import Collection from './Collections'

const Bookmarks = () => <Collection getMatchesUrl={getBookmarkedMatchesUrl} emptyPlaceholder="No bookmarks selected, get browsing!" />
export default Bookmarks
